import { useState, memo } from "react";
import { sections } from "../../data/sections.data";
import SectionCard from "./subComponents/SectionCard";

function Sections() {
  const [activeId, setActiveId] = useState(null);

  return (
    <div className="flex flex-col justify-start items-start w-full transition-transform duration-1000 ease-in-out">
      {sections.map((section) => (
        <SectionCard
          sectionData={section}
          key={section.id}
          activeId={activeId}
          setActive={setActiveId}
        />
      ))}
    </div>
  );
}

export default memo(Sections);
